<template>
  <div class="date-picker-outer-container">
    <div class="date-picker-container noselect" :style="style">
      <div class="calendar-nav">
        <v-icon
          small
          @click="prevMonth()"
          style="font-size: 20px; padding: 3px 6px 0px 7px;"
        >
          fa-chevron-circle-left
        </v-icon>
        <select
          v-model="checkInCalendarMonth"
          class="calendar-book-select-month"
          id="calendar-nav-month"
          name="calendar_month"
        >
          <option
            v-for="(month, index) in months"
            :key="index"
            :value="month.number"
          >
            {{ month.name }}
          </option>
        </select>
        <select
          v-model="checkInCalendarYear"
          class="calendar-book-select-year"
          id="calendar-nav-year"
          name="calendar_year"
        >
          <option
            v-for="(year, index) in years"
            :key="index"
            :value="year"
          >
            {{ year }}
          </option>
        </select>
        <v-icon
          small
          @click="nextMonth()"
          style=" padding: 3px 8px 0px 6px; font-size: 20px;"
        >
          fa-chevron-circle-right
        </v-icon>
        <v-icon
          small
          @click="closeNav()"
          style=" padding: 3px 7px 0px 9px; font-size: 20px;"
        >
          fa-times
        </v-icon>
      </div>
      <div id="calendar-container">
        <table class="calendar">
        <colgroup>
          <col class="esmaspäev">
          <col class="teisipäev">
          <col class="kolmapäev">
          <col class="neljapäev">
          <col class="reede">
          <col class="laupäev">
          <col class="pühapäev">
        </colgroup>
        <thead>
            <tr>
              <th
                v-for="(nullval, index) in [...Array(7)]"
                :key="index"
                :title="index"
              >
                {{ weekDayLetter(index) }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="week in Object.keys(monthWeekDays)"
              :key="week"
            >
              <!-- td class="pad">{{ week }}</td -->
              <td
                v-for="dayOfWeek in Object.keys(monthWeekDays[week])"
                :key="dayOfWeek"
                :class="dayClass(monthWeekDays[week][dayOfWeek])"
                :title="monthWeekDays[week][dayOfWeek].dayText"
                v-html="dayValue(monthWeekDays[week][dayOfWeek])"
                @click="selectDate(monthWeekDays[week][dayOfWeek])"
              >
            </td>
          </tr>
          </tbody>
        </table>
        <div class="py-2">
          <a
            v-if="value"
            href="javascript:;"
            class="clear-btn" @click="clearDate()"
          >
            {{ $i18n.t('clear_days') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from './../helper'
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'CalendarDatePicker',

  data: () => {
    return {
      firstWeekNumber: null,
      lastWeekNumber: null,
      firstDay: null
    }
  },

  props: {
    value: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      default: ''
    },
    left: {
      type: String,
      default: ''
    },
    mobilePadding: {
      type: Number,
      default: 0
    },
    startingFrom: {
      type: String,
      default: ''
    },
    forSearchForm: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    style () {
      return {
        left: this.left || '0px',
        width: (this.mobile && this.mobilePadding ? (window.innerWidth - this.mobilePadding * 2) : 277) + 'px'
      }
    },

    monthWeekDays () {
      moment.locale(this.lang)
      let firstWeekMonday = moment(this.firstDay).startOf('isoWeek').format('YYYY-MM-DD')
      let selectedMonthFirstDay = moment(this.checkInCalendarYear + '-' + this.checkInCalendarMonth + '-01')
      let selectedMonthNumber = selectedMonthFirstDay.format('M')

      const maxWeeks = 6
      let monthWeekDays = {}
      let monday = moment(firstWeekMonday)
      for (let j = 0; j <= maxWeeks; j++) {
        let sunday = moment(monday.format('YYYY-MM-DD')).add(6, 'days')
        let weekDays = {}

        // monday or sunday is within month
        if (monday.format('MM') === this.checkInCalendarMonth || sunday.format('MM') === this.checkInCalendarMonth) {
          for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
            let day = moment(monday.format('YYYY-MM-DD')).add(dayOfWeek, 'days')
            const isSelected = day.format('DD.MM.YYYY') === this.searchFilters.dateStart ||
              (this.searchFilters.dateStart && this.searchFilters.dateEnd &&
                day >= moment(helper.dateToYMD(this.searchFilters.dateStart)) &&
                day <= moment(helper.dateToYMD(this.searchFilters.dateEnd))
              )
            weekDays[dayOfWeek] = {
              day: day,
              isSelected: isSelected,
              dayDate: day.format('YYYY-MM-DD'),
              dayOfWeek: dayOfWeek,
              dayText: day.format('LL'),
              dayNumber: day.format('DD'),
              sameMonth: day.format('M') === selectedMonthNumber,
              passed: day.isBefore(moment().startOf('day').format()),
              today: day.format('DD-MM-YYYY') === moment().format('DD-MM-YYYY')
            }
          }
        }
        if (Object.keys(weekDays).length > 0) {
          monthWeekDays[j] = weekDays
        }
        monday = moment(sunday.format('YYYY-MM-DD')).add(1, 'day')
      }
      return monthWeekDays

    },

    years () {
      return [
        moment().format('Y'),
        parseInt(moment().format('Y')) + 1,
        parseInt(moment().format('Y')) + 2
      ]
    },

    months () {
      moment.locale(this.lang)
      let months = []
      for (let i = 1; i <= 12; i++) {
        let monthNumber = i.toString().length === 1 ? '0' + i.toString() : i.toString()
        months.push({
          number: moment('2000-' + monthNumber + '-01').format('MM'),
          name: moment('2000-' + monthNumber + '-01').format('MMMM')
        })
      }
      return months
    }
  },

  watch: {
    checkInCalendarYear (value, before) {
      const month = moment(this.checkInCalendarYear + '-' + this.checkInCalendarMonth + '-01')
      if (this.isMonthInTheFuture(month)) {
        this.updateWeekNumbers()
      } else {
        this.checkInCalendarYear = before
      }
    },

    checkInCalendarMonth (value, before) {
      const month = moment(this.checkInCalendarYear + '-' + this.checkInCalendarMonth + '-01')
      if (this.isMonthInTheFuture(month)) {
        this.updateWeekNumbers()
      } else {
        this.checkInCalendarMonth = before
      }
    },

    lang (value) {
      moment.locale(value)
    }
  },

  created () {
    moment.locale(this.$route.params && this.$route.params.lang || 'en')
    this.updateWeekNumbers()
  },

  methods: {

    isMonthInTheFuture (month) {
      return month.format('YYYYMM') >= moment().format('YYYYMM')
    },

    formatYMD (date) {
      let d = date.split('.')
      return d[2] + '-' + d[1] + '-' + d[0]
    },

    selectDate (date) {
      if (!this.isDateSelectable(date)) { return }
      this.$emit('update', {
        field: this.fieldName,
        value: moment(date.dayDate).format('DD.MM.YYYY')
      })
    },

    nextMonth () {
      let nextMonth = moment(this.checkInCalendarYear + '-' + this.checkInCalendarMonth + '-01').add(1, 'month')
      if (parseInt(nextMonth.format('YYYY')) <= parseInt(moment().format('YYYY')) + 2) {
        this.checkInCalendarYear = nextMonth.format('YYYY')
        this.checkInCalendarMonth = nextMonth.format('MM')
      }
    },

    prevMonth () {
      let prevMonth = moment(this.checkInCalendarYear + '-' + this.checkInCalendarMonth + '-01').subtract(1, 'month')
      if (this.isMonthInTheFuture(prevMonth)) {
        this.checkInCalendarYear = prevMonth.format('YYYY')
        this.checkInCalendarMonth = prevMonth.format('MM')
      }
    },

    dayValue (day) {
      if (!day.sameMonth) {
        return '&nbsp;'
      }
      return day.dayNumber
    },

    isDayPassedOrOverStartDay (date) {
      return !((moment(date).add(1, 'days') > moment() && !this.startingFrom) || (
        this.startingFrom && moment(date) > moment(this.formatYMD(this.startingFrom))
      ))
    },

    dayClass (day) {
      let classes = []
      if (!day || !day.sameMonth) {
        return 'day-picker-td'
      }
      if (day.isSelected) {
        classes.push('selected-day')
      }

      if (!this.isDayPassedOrOverStartDay(day.dayDate)) { // && !this.dayIsBooked(day.dayDate)
        classes.push('day-picker-td')
      } else if (this.startingFrom) {
        classes.push('passed')
      } else if (day.passed) {
        classes.push('passed')
      }

      if (moment(day.dayDate).format('DD.MM.YYYY') === this.value) {
        classes.push('day-picker-selected')
      }
      if (day.today) {
        classes.push('today')
      }
      // booked....
      let bookedStatus = this.dayIsBooked(day.dayDate)

      let previousDay = moment(moment(day.dayDate).subtract(1, 'day')).format('YYYY-MM-DD')
      let previousDayStatus = this.dayIsBooked(previousDay)

      if (['confirmed', 'new', 'owner', 'archived'].includes(bookedStatus)) {
        if (!previousDayStatus) {
          classes.push('pm_booked')
        } else {
          classes.push('booked')
        }
      } else if (['confirmed', 'new', 'archived', 'owner'].includes(previousDayStatus)) {
        classes.push('am_booked')
      }
      return classes.join(' ')
    },

    dayIsBooked (date) {
      if (this.forSearchForm) {
        return false
      }
      if (this.selectedObject && this.selectedObject.bookedDays) {
        if (this.selectedObject.bookedDays[date]) {
          return this.bookingStatuses[this.selectedObject.bookedDays[date]]
        }
      }
      return false
    },

    isDateSelectable (day) {
      if (this.isDayPassedOrOverStartDay(day.dayDate)) {
        return false
      }
      if (this.forSearchForm) {
        return true
      }
      let date = day.dayDate
      if (this.fieldName === 'dateEnd') {
        // Subtract 1 day because date end (checkout) can be on dates when
        // other visitors have booked (booking started)
        date = moment(date).subtract(1, 'day').format('YYYY-MM-DD')
      }
      if (this.selectedObject && this.selectedObject.bookedDays) {
        if (this.selectedObject.bookedDays[date]) {
          return !this.bookingStatuses[this.selectedObject.bookedDays[date]]
        }
      }
      return true
    },

    weekDayLetter (index) {
      return moment().startOf('isoWeek').add(index, 'days').format('dd')
    },

    updateWeekNumbers () {
      this.firstDay = this.checkInCalendarYear + '-' + this.checkInCalendarMonth + '-01'
      this.firstWeekNumber = moment(this.checkInCalendarYear + '-' + this.checkInCalendarMonth + '-01')
        .format('w')
      this.lastWeekNumber = moment(this.firstDay).endOf('month').format('w')
    },

    clearDate () {
      this.$emit('update', {
        field: this.fieldName,
        value: null
      })
      this.closeNav()
    },

    closeNav () {
      this.showSearchPickerFor = null
      this.showBookingPickerFor = null
    }
  }
}
</script>

<style>
.clear-btn {
  cursor: pointer;
  padding: 4px 0;
}
.booked {
  cursor: not-allowed !important;
}
.calendar-book-select-month {
  width: calc(100% - 165px);
}

.calendar-book-select-year {
  width: 60px;
}
.date-picker-outer-container {
  position: relative;
  width: 1px;
  height:1px;
  z-index: 2; /* booking extras select over div otherwise blocks */
}
.date-picker-container {
  margin-top: 0px;
  background: white;
  position: absolute;
  top: 1px;
  text-align: center;
  padding: 4px;
  box-shadow: 3px 3px 5px #888;
}
.calendar-nav {
  background: #fff url(../../public/img/ui-bg_highlight-soft_75_ffad00_1x100.png) 50% 50% repeat-x;
  border-radius: 4px;
  border: 1px solid #aaa;
  padding: 5px 0 3px 0px;
}
#calendar-nav-prev {
  margin-right: 4px !important;
}
#calendar-nav-next {
  margin-left: 4px !important;
}
#calendar-nav-month {
  margin-right: 2px !important;
}
.day-picker-td {
  cursor: pointer;
}
.day-picker-td:hover {
  background: #ddd;
}
.day-picker-selected {
  background: #219bc8 !important;
  color: white !important;
}
</style>
